export const SCOUT_IMAGE_MEDIA_TYPES = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
] as const;

export function isScoutImageMediaType(
  mediaType: string | undefined
): mediaType is (typeof SCOUT_IMAGE_MEDIA_TYPES)[number] {
  return SCOUT_IMAGE_MEDIA_TYPES.some((supported) => supported === mediaType);
}
